// Estado da trava de report pendente (`state.account.reportLock`).
//
// A trava é SEMPRE derivada do servidor: não existe "usuário bloqueado" no front. Duas fontes a atualizam:
//  - GET /api/users/report_pendencies (`appointment/GET_REPORT_PENDENCIES`, chamado pelo guard de rotas
//    via `account/REFRESH_REPORT_LOCK` e pela central de pendências);
//  - o 423 APPOINTMENT_REPORT_PENDING de qualquer requisição (interceptor de `helpers/api.js`).

// Por quanto tempo o guard reaproveita a última checagem antes de consultar o servidor de novo.
export const REPORT_LOCK_TTL_MS = 30 * 1000

export const initialReportLock = () => ({
  locked: false,
  pendingIds: [],
  count: 0,
  checkedAt: null,
})

const toIds = ids => (Array.isArray(ids) ? ids : [])
  .map(Number)
  .filter(id => Number.isInteger(id) && id > 0)

/** Contagem vinda da API: número inteiro ≥ 0, ou `fallback` (null/undefined/texto não viram 0). */
export const toPendingCount = (value, fallback) => {
  if (value === null || value === undefined || value === '') return fallback
  const count = Number(value)

  return Number.isInteger(count) && count >= 0 ? count : fallback
}

export const normalizeReportLock = lock => {
  const pendingIds = toIds(lock && lock.pendingIds)

  return {
    locked: !!(lock && lock.locked),
    pendingIds,
    count: toPendingCount(lock && lock.count, pendingIds.length),
    checkedAt: lock && Number.isFinite(lock.checkedAt) ? lock.checkedAt : null,
  }
}

export const isReportLockFresh = (lock, now = Date.now()) => !!(lock && lock.checkedAt)
  && now - lock.checkedAt < REPORT_LOCK_TTL_MS

/**
 * Converte a resposta de GET /api/users/report_pendencies (`{ data: [...], count, blocked, server_now }`)
 * no estado da trava. `blocked` vem do servidor (considera o modo off/log/enforce); sem ele, vale a lista.
 */
export const reportLockFromPendencies = (body, checkedAt = Date.now()) => {
  const items = body && Array.isArray(body.data) ? body.data : []
  const pendingIds = toIds(items.map(item => item && item.id))

  return normalizeReportLock({
    locked: body && typeof body.blocked === 'boolean' ? body.blocked : pendingIds.length > 0,
    pendingIds,
    count: toPendingCount(body && body.count, pendingIds.length),
    checkedAt,
  })
}

/** O compromisso está entre as pendências conhecidas (o report dele passa pela trava). */
export const isPendingAppointment = (lock, appointmentId) => !!lock
  && toIds(lock.pendingIds).includes(Number(appointmentId))
